import React, { useState, useEffect, useContext, useRef } from "react";
import "emoji-mart/css/emoji-mart.css";
import { useParams } from "react-router-dom";
import { Picker } from "emoji-mart";
import clsx from "clsx";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import CircularProgress from "@material-ui/core/CircularProgress";
import { green } from "@material-ui/core/colors";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import PictureAsPdfOutlinedIcon from "@material-ui/icons/PictureAsPdfOutlined";
import Tooltip from "@material-ui/core/Tooltip";
import EscolherManual from "./EscolherManual";
import { usePermissao } from "../../suporte/permissoes";
import IconButton from "@material-ui/core/IconButton";
import MoreVert from "@material-ui/icons/MoreVert";
import MoodIcon from "@material-ui/icons/Mood";
import SendIcon from "@material-ui/icons/Send";
import CancelIcon from "@material-ui/icons/Cancel";
import ClearIcon from "@material-ui/icons/Clear";
import MicIcon from "@material-ui/icons/Mic";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import {
  FormControlLabel,
  Hidden,
  Menu,
  MenuItem,
  Switch,
} from "@material-ui/core";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import RecordingTimer from "./RecordingTimer";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { AuthContext } from "../../context/Auth/AuthContext";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";
import { getBackendUrl } from "../../config";
import suporteApi, { mensagemErro } from "../../suporte/api";

let Mp3Recorder = null;

const initRecorder = async () => {
  if (!Mp3Recorder) {
    try {
      const MicRecorder = (await import("mic-recorder-to-mp3")).default;
      Mp3Recorder = new MicRecorder({ bitRate: 128 });
    } catch (error) {
      console.error("Failed to initialize recorder:", error);
      return null;
    }
  }
  return Mp3Recorder;
};

const useStyles = makeStyles(theme => ({
  mainWrapper: {
    background: "#eee",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
    [theme.breakpoints.down("sm")]: {
      position: "fixed",
      bottom: 0,
      width: "100%",
    },
  },

  newMessageBox: {
    background: "#eee",
    width: "100%",
    display: "flex",
    padding: "7px",
    alignItems: "center",
  },

  messageInputWrapper: {
    padding: 6,
    marginRight: 7,
    background: "#fff",
    display: "flex",
    borderRadius: 20,
    flex: 1,
    position: "relative",
  },

  messageInput: {
    paddingLeft: 10,
    flex: 1,
    border: "none",
  },

  sendMessageIcons: {
    color: "grey",
  },

  uploadInput: {
    display: "none",
  },

  viewMediaInputWrapper: {
    display: "flex",
    padding: "10px 13px",
    position: "relative",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#eee",
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
  },

  emojiBox: {
    position: "absolute",
    bottom: 63,
    width: 40,
    borderTop: "1px solid #e8e8e8",
  },

  circleLoading: {
    color: green[500],
    opacity: "70%",
    position: "absolute",
    top: "20%",
    left: "50%",
    marginLeft: -12,
  },

  audioLoading: {
    color: green[500],
    opacity: "70%",
  },

  recorderWrapper: {
    display: "flex",
    alignItems: "center",
    alignContent: "middle",
  },

  cancelAudioIcon: {
    color: "red",
  },

  sendAudioIcon: {
    color: "green",
  },

  replyginMsgWrapper: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 8,
    paddingLeft: 73,
    paddingRight: 7,
  },

  replyginMsgContainer: {
    flex: 1,
    marginRight: 5,
    overflowY: "hidden",
    backgroundColor: "rgba(0, 0, 0, 0.05)",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },

  replyginMsgBody: {
    padding: 10,
    height: "auto",
    display: "block",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
  },

  replyginContactMsgSideColor: {
    flex: "none",
    width: "4px",
    backgroundColor: "#35cd96",
  },

  replyginSelfMsgSideColor: {
    flex: "none",
    width: "4px",
    backgroundColor: "#6bcbef",
  },

  messageContactName: {
    display: "flex",
    color: "#6bcbef",
    fontWeight: 500,
  },
  messageQuickAnswersWrapper: {
    margin: 0,
    position: "absolute",
    bottom: "50px",
    background: "#ffffff",
    padding: "2px",
    border: "1px solid #CCC",
    left: 0,
    width: "100%",
    "& li": {
      listStyle: "none",
      "& a": {
        display: "block",
        padding: "8px",
        textOverflow: "ellipsis",
        overflow: "hidden",
        maxHeight: "32px",
        "&:hover": {
          background: "#F1F1F1",
          cursor: "pointer",
        },
      },
    },
  },
}));

const MessageInput = ({ ticketStatus, queueId, isGroup }) => {
  const classes = useStyles();
  const podeEnviarManual = usePermissao("manuais.enviar");
  const { ticketId } = useParams();

  const [medias, setMedias] = useState([]);
  const [inputMessage, setInputMessage] = useState("");
  const [showEmoji, setShowEmoji] = useState(false);
  const [loading, setLoading] = useState(false);
  const [recording, setRecording] = useState(false);
  const [quickAnswers, setQuickAnswer] = useState([]);
  const [typeBar, setTypeBar] = useState(false);
  const [escolherAnexo, setEscolherAnexo] = useState(false); // manuais (ícone PDF)
  const [manualPendente, setManualPendente] = useState(null); // manual carregado no campo: conta no relatório ao enviar
  const inputRef = useRef();
  const [anchorEl, setAnchorEl] = useState(null);
  const { setReplyingMessage, replyingMessage } =
    useContext(ReplyMessageContext);
  const { user } = useContext(AuthContext);

  const [signMessage, setSignMessage] = useLocalStorage("signOption", true);
  // nota interna: fica no ticket só para a equipe (suporte-app), não vai para o WhatsApp; @Nome avisa o colega no celular
  const [notaInterna, setNotaInterna] = useState(false);
  const [usuariosMenc, setUsuariosMenc] = useState([]);
  useEffect(() => {
    if (notaInterna && !usuariosMenc.length) {
      suporteApi.get("/api/usuarios/mencionaveis").then(({ data }) => setUsuariosMenc(data)).catch(() => {});
    }
  }, [notaInterna, usuariosMenc.length]);
  const termoMencao = notaInterna ? ((inputMessage || "").match(/@([^@\n]{0,30})$/) || [])[1] : undefined;
  const sugestoesMencao = termoMencao === undefined ? [] : usuariosMenc
    .filter((x) => x.nome.toLowerCase().includes(termoMencao.toLowerCase())).slice(0, 6);
  const mencionar = (x) => setInputMessage((s) => s.replace(/@([^@\n]{0,30})$/, `@${x.nome} `));

  useEffect(() => {
    inputRef.current.focus();
  }, [replyingMessage]);

  useEffect(() => {
    inputRef.current.focus();
    return () => {
      setInputMessage("");
      setShowEmoji(false);
      setMedias([]);
      setManualPendente(null);
      setReplyingMessage(null);
    };
  }, [ticketId, setReplyingMessage]);

  const handleChangeInput = e => {
    setInputMessage(e.target.value);
    handleLoadQuickAnswer(e.target.value);
  };

  // anexos da resposta rápida viram arquivos prontos para enviar (como pelo clipe)
  const carregarAnexos = async anexos => {
    const base = (getBackendUrl() || "").replace(/\/$/, "");
    const arquivos = await Promise.all(
      anexos.map(async a => {
        const r = await fetch(`${base}/public/${encodeURIComponent(a.arquivo)}`);
        if (!r.ok) throw new Error(`Anexo não encontrado: ${a.nome}`);
        return new File([await r.blob()], a.nome, { type: a.tipo });
      })
    );
    setMedias(arquivos);
  };

  // manual (menu Manuais): arquivos prontos para enviar + texto (com as mesmas variáveis)
  const handleManual = async (manual, comoLink = false) => {
    if (comoLink) { // link rastreável desta conversa: o envio já fica registrado no manual (métricas)
      try {
        const { data } = await suporteApi.post(`/api/manuais/${manual.id}/link`, { ticket_id: Number(ticketId) || null });
        setInputMessage(data.texto);
      } catch (err) {
        toast.error(`Não foi possível gerar o link do manual: ${mensagemErro(err)}`);
      }
      return;
    }
    try {
      const arquivos = await Promise.all(
        (manual.arquivos || []).map(async a => {
          const { data } = await suporteApi.get(a.url, { responseType: "blob" });
          return new File([data], a.nome, { type: a.tipo || data.type });
        })
      );
      setMedias(arquivos);
      setManualPendente({ id: manual.id, nomes: arquivos.map((a) => a.name).sort().join("|") });
    } catch (err) {
      toast.error(`Não foi possível carregar o manual: ${mensagemErro(err)}`);
      return;
    }
    await handleQuickAnswersClick({ message: manual.mensagem || "", anexos: [] });
  };

  const handleQuickAnswersClick = async resposta => {
    setTypeBar(false);
    const value = [resposta.message, resposta.link].filter(Boolean).join("\n");
    if ((resposta.anexos || []).length) {
      try {
        await carregarAnexos(resposta.anexos);
      } catch (err) {
        toast.error(err.message);
      }
    }
    if (!value.includes("{{")) {
      setInputMessage(value);
      return;
    }
    // variáveis da resposta rápida ({{os}}, {{conta}}…) com os dados do card desta conversa
    let texto = value;
    try {
      // {{formulario:ID}}: link único do formulário no card desta conversa (gerado na hora)
      const forms = [...new Set((texto.match(/\{\{\s*formulario:[^}]+\}\}/g) || []))];
      for (const v of forms) {
        const ref = v.replace(/^\{\{\s*formulario:/, "").replace(/\s*\}\}$/, "").trim();
        const { data } = await suporteApi.post(`/api/whaticket/tickets/${ticketId}/formulario/${encodeURIComponent(ref)}`);
        texto = texto.split(v).join(data.link);
        toast.info(`${data.formulario}: link gerado no card${data.validade ? ` (vale até ${data.validade})` : ""}`);
      }
      if (texto.includes("{{protocolo}}")) {
        // gera (ou reaproveita) o protocolo do card desta conversa
        const { data } = await suporteApi.post(`/api/whaticket/tickets/${ticketId}/protocolo`);
        texto = texto.split("{{protocolo}}").join(data.texto);
      }
      if (/\{\{\s*\w+\s*\}\}/.test(texto)) {
        const { data } = await suporteApi.get(`/api/whaticket/tickets/${ticketId}/variaveis`);
        const vazias = [];
        texto = texto.replace(/\{\{\s*(\w+)\s*\}\}/g, (todo, nome) => {
          const v = data.variaveis[nome];
          if (v) return v;
          vazias.push(nome);
          return "";
        });
        if (vazias.length) {
          toast.warn(data.card
            ? `Sem valor no card: ${vazias.join(", ")}`
            : `Conversa sem card: ${vazias.join(", ")} ficou em branco`);
        }
      }
      setInputMessage(texto);
    } catch (err) {
      toast.error(mensagemErro(err));
    }
  };

  const handleAddEmoji = e => {
    let emoji = e.native;
    setInputMessage(prevState => prevState + emoji);
  };

  const handleChangeMedias = e => {
    if (!e.target.files) {
      return;
    }

    const selectedMedias = Array.from(e.target.files);
    setMedias(selectedMedias);
  };

  const handleInputPaste = e => {
    if (e.clipboardData.files[0]) {
      setMedias([e.clipboardData.files[0]]);
    }
  };

  const handleUploadMedia = async e => {
    setLoading(true);
    e.preventDefault();

    if (inputMessage.trim()) {
      try {
        await api.post(`/messages/${ticketId}`, {
          read: 1,
          fromMe: true,
          mediaUrl: "",
          body: signMessage ? `*${user?.name}:*\n${inputMessage.trim()}` : inputMessage.trim(),
        });
        setInputMessage("");
      } catch (err) {
        toastError(err);
      }
    }

    const formData = new FormData();
    formData.append("fromMe", true);
    medias.forEach(media => {
      formData.append("medias", media);
      formData.append("body", media.name);
    });

    try {
      await api.post(`/messages/${ticketId}`, formData);
      // mesmos arquivos do manual escolhido: registra o envio (relatório de manuais por operador)
      if (manualPendente && manualPendente.nomes === medias.map((m) => m.name).sort().join("|")) {
        suporteApi.post(`/api/manuais/${manualPendente.id}/envios`, { ticket_id: Number(ticketId) || null }).catch(() => {});
      }
    } catch (err) {
      toastError(err);
    }

    setLoading(false);
    setMedias([]);
    setManualPendente(null);
  };

  const podeEnviarPesquisa = usePermissao("satisfacao.enviar");
  const handleEnviarPesquisa = async () => {
    try {
      const { data } = await suporteApi.post(`/api/whaticket/tickets/${ticketId}/pesquisa`);
      toast.success(data.canal === "bot" ? "Pesquisa iniciada pelo chatbot" : "Link da pesquisa enviado");
    } catch (err) {
      toast.error(mensagemErro(err));
    }
  };

  const handleSendMessage = async () => {
    if (inputMessage.trim() === "") return;
    setLoading(true);
    if (notaInterna) {
      try {
        const { data } = await suporteApi.post(`/api/tickets/${ticketId}/notas`, { texto: inputMessage.trim() });
        if (data.avisados?.length) toast.info(`Aviso no celular: ${data.avisados.join(", ")}`);
        window.dispatchEvent(new CustomEvent("notas-internas", { detail: Number(ticketId) }));
        setInputMessage("");
      } catch (err) {
        toast.error(mensagemErro(err));
      }
      setLoading(false);
      return;
    }

    const message = {
      read: 1,
      fromMe: true,
      mediaUrl: "",
      body: signMessage
        ? `*${user?.name}:*\n${inputMessage.trim()}`
        : inputMessage.trim(),
      quotedMsg: replyingMessage,
    };
    try {
      await api.post(`/messages/${ticketId}`, message);
    } catch (err) {
      toastError(err);
    }

    setInputMessage("");
    setShowEmoji(false);
    setLoading(false);
    setReplyingMessage(null);
  };

  const handleStartRecording = async () => {
    setLoading(true);
    try {
      const recorder = await initRecorder();
      if (!recorder) {
        throw new Error("Recorder not available");
      }
      await navigator.mediaDevices.getUserMedia({ audio: true });
      await recorder.start();
      setRecording(true);
      setLoading(false);
    } catch (err) {
      toastError(err);
      setLoading(false);
    }
  };

  const handleLoadQuickAnswer = async value => {
    if (value && value.indexOf("/") === 0) {
      try {
        const { data } = await api.get("/quickAnswers/", {
          // só as respostas da fila deste ticket (e as que valem para todas)
          params: { searchParam: inputMessage.substring(1), queueId: queueId || undefined },
        });
        setQuickAnswer(data.quickAnswers);
        if (data.quickAnswers.length > 0) {
          setTypeBar(true);
        } else {
          setTypeBar(false);
        }
      } catch (err) {
        setTypeBar(false);
      }
    } else {
      setTypeBar(false);
    }
  };

  const handleUploadAudio = async () => {
    setLoading(true);
    try {
      const recorder = await initRecorder();
      if (!recorder) {
        throw new Error("Recorder not available");
      }
      const [, blob] = await recorder.stop().getMp3();
      if (blob.size < 10000) {
        setLoading(false);
        setRecording(false);
        return;
      }

      const formData = new FormData();
      const filename = `${new Date().getTime()}.mp3`;
      formData.append("medias", blob, filename);
      formData.append("body", filename);
      formData.append("fromMe", true);

      await api.post(`/messages/${ticketId}`, formData);
    } catch (err) {
      toastError(err);
    }

    setRecording(false);
    setLoading(false);
  };

  const handleCancelAudio = async () => {
    try {
      const recorder = await initRecorder();
      if (recorder) {
        await recorder.stop().getMp3();
      }
      setRecording(false);
    } catch (err) {
      toastError(err);
    }
  };

  const handleOpenMenuClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = event => {
    setAnchorEl(null);
  };

  const renderReplyingMessage = message => {
    return (
      <div className={classes.replyginMsgWrapper}>
        <div className={classes.replyginMsgContainer}>
          <span
            className={clsx(classes.replyginContactMsgSideColor, {
              [classes.replyginSelfMsgSideColor]: !message.fromMe,
            })}
          ></span>
          <div className={classes.replyginMsgBody}>
            {!message.fromMe && (
              <span className={classes.messageContactName}>
                {message.contact?.name}
              </span>
            )}
            {message.body}
          </div>
        </div>
        <IconButton
          aria-label="showRecorder"
          component="span"
          disabled={loading || ticketStatus !== "open"}
          onClick={() => setReplyingMessage(null)}
        >
          <ClearIcon className={classes.sendMessageIcons} />
        </IconButton>
      </div>
    );
  };

  if (medias.length > 0)
    return (
      <Paper elevation={0} square className={classes.viewMediaInputWrapper}>
        <IconButton
          aria-label="cancel-upload"
          component="span"
          onClick={e => { setMedias([]); }}
        >
          <CancelIcon className={classes.sendMessageIcons} />
        </IconButton>

        {loading ? (
          <div>
            <CircularProgress className={classes.circleLoading} />
          </div>
        ) : (
          <span style={{ display: "flex", flexDirection: "column", overflow: "hidden" }}>
            {inputMessage.trim() && (
              <span style={{ fontSize: 12, opacity: 0.75, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                {`Texto: ${inputMessage.trim()}`}
              </span>
            )}
            <span>{medias.map((m) => m.name).join(", ")}</span>
          </span>
        )}
        <IconButton
          aria-label="send-upload"
          component="span"
          onClick={handleUploadMedia}
          disabled={loading}
        >
          <SendIcon className={classes.sendMessageIcons} />
        </IconButton>
      </Paper>
    );
  else {
    return (
      <Paper square elevation={0} className={classes.mainWrapper}>
        <EscolherManual
          open={escolherAnexo}
          onClose={() => setEscolherAnexo(false)}
          queueId={queueId}
          onEscolher={handleManual}
        />
        {replyingMessage && renderReplyingMessage(replyingMessage)}
        <div className={classes.newMessageBox}>
          <Hidden only={["sm", "xs"]}>
            <IconButton
              aria-label="emojiPicker"
              component="span"
              disabled={loading || recording || ticketStatus !== "open"}
              onClick={e => setShowEmoji(prevState => !prevState)}
            >
              <MoodIcon className={classes.sendMessageIcons} />
            </IconButton>
            {showEmoji ? (
              <div className={classes.emojiBox}>
                <ClickAwayListener onClickAway={e => setShowEmoji(false)}>
                  <Picker
                    perLine={16}
                    showPreview={false}
                    showSkinTones={false}
                    onSelect={handleAddEmoji}
                  />
                </ClickAwayListener>
              </div>
            ) : null}

            <input
              multiple
              type="file"
              id="upload-button"
              disabled={loading || recording || ticketStatus !== "open"}
              className={classes.uploadInput}
              onChange={handleChangeMedias}
            />
            <label htmlFor="upload-button">
              <IconButton
                aria-label="upload"
                component="span"
                disabled={loading || recording || ticketStatus !== "open"}
              >
                <AttachFileIcon className={classes.sendMessageIcons} />
              </IconButton>
            </label>
            {!isGroup && (<Tooltip title="Enviar pesquisa de satisfação (o chatbot conduz na conversa)">
              <span>
                <IconButton
                  aria-label="enviar pesquisa"
                  id="botao-enviar-pesquisa"
                  disabled={!podeEnviarPesquisa || loading || recording}
                  onClick={handleEnviarPesquisa}
                >
                  <StarBorderIcon className={classes.sendMessageIcons} />
                </IconButton>
              </span>
            </Tooltip>)}
            <Tooltip title="Enviar manual (PDF, imagem, vídeo)">
              <span>
                <IconButton
                  aria-label="enviar manual"
                  disabled={!podeEnviarManual || loading || recording || ticketStatus !== "open"}
                  onClick={() => setEscolherAnexo(true)}
                >
                  <PictureAsPdfOutlinedIcon className={classes.sendMessageIcons} />
                </IconButton>
              </span>
            </Tooltip>
            <FormControlLabel
              style={{ marginRight: 7, color: "gray" }}
              label={i18n.t("messagesInput.signMessage")}
              labelPlacement="start"
              control={
                <Switch
                  size="small"
                  checked={signMessage}
                  onChange={e => {
                    setSignMessage(e.target.checked);
                  }}
                  name="showAllTickets"
                  color="primary"
                />
              }
            />
          </Hidden>
          <Hidden only={["md", "lg", "xl"]}>
            <IconButton
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleOpenMenuClick}
            >
              <MoreVert></MoreVert>
            </IconButton>
            <Menu
              id="simple-menu"
              keepMounted
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuItemClick}
            >
              <MenuItem onClick={handleMenuItemClick}>
                <IconButton
                  aria-label="emojiPicker"
                  component="span"
                  disabled={loading || recording || ticketStatus !== "open"}
                  onClick={e => setShowEmoji(prevState => !prevState)}
                >
                  <MoodIcon className={classes.sendMessageIcons} />
                </IconButton>
              </MenuItem>
              <MenuItem onClick={handleMenuItemClick}>
                <input
                  multiple
                  type="file"
                  id="upload-button"
                  disabled={loading || recording || ticketStatus !== "open"}
                  className={classes.uploadInput}
                  onChange={handleChangeMedias}
                />
                <label htmlFor="upload-button">
                  <IconButton
                    aria-label="upload"
                    component="span"
                    disabled={loading || recording || ticketStatus !== "open"}
                  >
                    <AttachFileIcon className={classes.sendMessageIcons} />
                  </IconButton>
                </label>
              </MenuItem>
              <MenuItem onClick={handleMenuItemClick}>
                <IconButton
                  aria-label="enviar manual"
                  disabled={!podeEnviarManual || loading || recording || ticketStatus !== "open"}
                  onClick={() => setEscolherAnexo(true)}
                >
                  <PictureAsPdfOutlinedIcon className={classes.sendMessageIcons} />
                </IconButton>
              </MenuItem>
              <MenuItem onClick={handleMenuItemClick}>
                <FormControlLabel
                  style={{ marginRight: 7, color: "gray" }}
                  label={i18n.t("messagesInput.signMessage")}
                  labelPlacement="start"
                  control={
                    <Switch
                      size="small"
                      checked={signMessage}
                      onChange={e => {
                        setSignMessage(e.target.checked);
                      }}
                      name="showAllTickets"
                      color="primary"
                    />
                  }
                />
              </MenuItem>
            </Menu>
          </Hidden>
          <Tooltip title={notaInterna ? "Nota interna ligada: só a equipe vê (clique para voltar à mensagem)" : "Nota interna (só a equipe vê; @Nome avisa o colega)"}>
            <IconButton aria-label="nota interna" id="botao-nota-interna" onClick={() => setNotaInterna((x) => !x)}
              style={notaInterna ? { color: "#b7791f", background: "#fff6c2" } : undefined}>
              <LockOutlinedIcon className={classes.sendMessageIcons} style={notaInterna ? { color: "#b7791f" } : undefined} />
            </IconButton>
          </Tooltip>
          <div className={classes.messageInputWrapper} style={notaInterna ? { background: "#fff6c2" } : undefined}>
            <InputBase
              inputRef={input => {
                input && input.focus();
                input && (inputRef.current = input);
              }}
              className={classes.messageInput}
              placeholder={
                notaInterna
                  ? "Nota interna — só a equipe vê. Use @Nome para avisar um colega no celular"
                  : ticketStatus === "open"
                  ? i18n.t("messagesInput.placeholderOpen")
                  : i18n.t("messagesInput.placeholderClosed")
              }
              multiline
              maxRows={5}
              value={inputMessage}
              onChange={handleChangeInput}
              disabled={recording || loading || (ticketStatus !== "open" && !notaInterna)}
              onPaste={e => {
                ticketStatus === "open" && handleInputPaste(e);
              }}
              onKeyPress={e => {
                if (loading || e.shiftKey) return;
                else if (e.key === "Enter") {
                  handleSendMessage();
                }
              }}
            />
            {sugestoesMencao.length > 0 && (
              <ul className={classes.messageQuickAnswersWrapper}>
                {sugestoesMencao.map((x) => (
                  <li key={x.id} className={classes.messageQuickAnswersWrapperItem}>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a onClick={() => mencionar(x)}>{`@${x.nome}`}</a>
                  </li>
                ))}
              </ul>
            )}
            {typeBar && !notaInterna ? (
              <ul className={classes.messageQuickAnswersWrapper}>
                {quickAnswers.map((value, index) => {
                  return (
                    <li
                      className={classes.messageQuickAnswersWrapperItem}
                      key={index}
                    >
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a onClick={() => handleQuickAnswersClick(value)}>
                        {`${(value.anexos || []).length ? "📎 " : ""}${value.shortcut} - ${value.message}`}
                      </a>
                    </li>
                  );
                })}
              </ul>
            ) : (
              <div></div>
            )}
          </div>
          {inputMessage ? (
            <IconButton
              aria-label="sendMessage"
              component="span"
              onClick={handleSendMessage}
              disabled={loading}
            >
              <SendIcon className={classes.sendMessageIcons} />
            </IconButton>
          ) : recording ? (
            <div className={classes.recorderWrapper}>
              <IconButton
                aria-label="cancelRecording"
                component="span"
                fontSize="large"
                disabled={loading}
                onClick={handleCancelAudio}
              >
                <HighlightOffIcon className={classes.cancelAudioIcon} />
              </IconButton>
              {loading ? (
                <div>
                  <CircularProgress className={classes.audioLoading} />
                </div>
              ) : (
                <RecordingTimer />
              )}

              <IconButton
                aria-label="sendRecordedAudio"
                component="span"
                onClick={handleUploadAudio}
                disabled={loading}
              >
                <CheckCircleOutlineIcon className={classes.sendAudioIcon} />
              </IconButton>
            </div>
          ) : (
            <IconButton
              aria-label="showRecorder"
              component="span"
              disabled={loading || ticketStatus !== "open"}
              onClick={handleStartRecording}
            >
              <MicIcon className={classes.sendMessageIcons} />
            </IconButton>
          )}
        </div>
      </Paper>
    );
  }
};

export default MessageInput;
